import React from 'react'
import { Box, Typography } from '@mui/material'
import { sectionNotFoundSx } from './style'

const SectionNotFound = ({tab}) => {
    return (
        <Box sx={sectionNotFoundSx.root}>
            <Typography sx={sectionNotFoundSx.textOne} color={'primary'} >Section not found</Typography>
            <Typography variant="body1" sx={sectionNotFoundSx.textTwo}>The section "{tab}" does not exist.</Typography>
        </Box>
    )
}

export default SectionNotFound
